import React from 'react';
import PillBadge from './PillBadge';
import { formatHybridDate } from '../utils/date';

const STATUS_VARIANT = {
  pending: 'default',
  processing: 'info',
  done: 'success',
  failed: 'danger',
};

const STATUS_LABEL = {
  pending: 'En attente',
  processing: 'En cours',
  done: 'Envoyé',
  failed: 'Échec',
};

export default function CsvImportRow({ importItem }) {
  if (!importItem) return null;
  const variant = STATUS_VARIANT[importItem.status] || 'default';
  const label = STATUS_LABEL[importItem.status] || importItem.status || 'Inconnu';

  return (
    <div style={styles.row}>
      <span style={styles.icon} aria-hidden>📄</span>
      <div style={styles.body}>
        <div style={styles.titleRow}>
          <span style={styles.filename}>{importItem.filename || 'Import'}</span>
          <PillBadge label={label} variant={variant} />
        </div>
        <div style={styles.meta}>
          {formatHybridDate(importItem.created_at)} · {importItem.sent_rows || 0}/{importItem.total_rows || 0} envoyés
          {importItem.source ? ` · ${importItem.source}` : ''}
        </div>
      </div>
    </div>
  );
}

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    borderBottom: '1px solid #EDEAE3',
  },
  icon: {
    fontSize: 18,
    width: 32,
    height: 32,
    background: '#FFF5F0',
    borderRadius: 10,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  body: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
  },
  filename: {
    fontSize: 14,
    fontWeight: 600,
    color: '#1A1A1A',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
  meta: {
    fontSize: 12,
    color: '#6B6B6B',
  },
};
